import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import InbarTracker from './InbarTracker';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <InbarTracker />
  </StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* offline support is a bonus, not a requirement */
    });
  });
}
